import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import { Loader } from 'lucide-react';

const SuperAdminRouteGuard = () => {
    const { user, loading } = useAuth();

    // While the authentication state is loading, we show a loading screen.
    // This prevents the guard from redirecting before it knows if the user is logged in.
    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-900">
                <Loader className="animate-spin text-cyan-400" size={48} />
            </div>
        );
    }

    // After loading, if the user exists and is a superadmin, allow access.
    if (user && user.role === 'superadmin') {
        return <Outlet />;
    }

    // If the user is not a superadmin (or not logged in), redirect to the admin login page.
    return <Navigate to="/admin/login" replace />;
};

export default SuperAdminRouteGuard; 